import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ActionNotification from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/AdvancedSpamProtection/ActionNotification';
import ApproveBlockList from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/AdvancedSpamProtection/ApproveBlockList';
import Rules from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/AdvancedSpamProtection/Rules';

const AdvanceSpamProtection = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.approvedAndBlockedLists')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules
              applyBoundShow={false}
              asDetectionTechniqueShow={true}
              asSuspiciousDetectionShow={false}
              asRetroScanShow={false}
            />
          </TabPanel>
          <TabPanel>
            <ApproveBlockList approvedHeaderFieldsShow={false} />
          </TabPanel>
          <TabPanel>
            <ActionNotification />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(AdvanceSpamProtection);
